// src/index.js
import 'bootstrap/dist/css/bootstrap.min.css'; // <--- ADD THIS LINE
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css'; // This is your default CRA index.css if you have one
import reportWebVitals from './reportWebVitals';
import './styles/global.css'; // <--- ADD THIS LINE (assuming you put global.css in src/styles)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();